import styles from './Header.module.scss';
import { ReactComponent as LogoSVG } from '../../../assets/logo.svg';
import { useContext } from 'react';
import { UserContext } from '../../../context/UserContext';
import { AuthContext } from '../../../context/AuthContext';
import { Link, useLocation } from 'react-router-dom';

export const Header = () => {
    const { userState } = useContext(UserContext);
    const { signOut } = useContext(AuthContext);
    const location = useLocation();
    return (
        <div className={styles.container}>
            <div className={styles.flex}>
                <LogoSVG />
            </div>
            <div className={styles.menu}>
                <Link className={[styles.link, location.pathname === '/' ? styles.active : ''].join(' ')} to={'/'}>
                    Transactions
                </Link>
                <Link
                    className={[styles.link, location.pathname === '/challenges' ? styles.active : ''].join(' ')}
                    to={'/challenges'}
                >
                    Challenges
                </Link>
                <Link
                    className={[styles.link, location.pathname.startsWith('/tournaments') ? styles.active : ''].join(' ')}
                    to={'/tournaments'}
                >
                    Tournaments
                </Link>
            </div>
            <div onClick={signOut} className={styles.phone}>
                {userState?.userPhone}
            </div>
        </div>
    );
};
